import React from 'react';
import { FaUnlock } from 'react-icons/fa';

interface UnlockIconProps {
  size?: number;
  color?: string;
  className?: string;
}

const UnlockIcon: React.FC<UnlockIconProps> = ({ 
  size = 16, 
  color = 'currentColor',
  className = ''
}) => {
  return (
    <FaUnlock
      size={size}
      color={color}
      className={className}
      title="Déverrouiller la tournée"
    />
  );
};

export default UnlockIcon;